const GENERAL = {
  status: "",
  message: "",
  data: []
}

export {
  GENERAL
}
